import React, { useCallback, useRef, useState } from 'react'
import { SLowcodeList, STableActions, SActionBtn } from 'shj-components'
import { Button, Col, DatePicker, Row, Table, Tabs, Select, Badge, Image } from 'antd'
import { get } from 'lodash-es'
import config from './config'
import styles from '../../../index.module.less'
import { useSetState } from 'ahooks'
import { compensationSigningPage, ticketsListAccept, ticketsBack } from '@/services/homeService'
import { log } from 'console'
import { getUser } from '@/common/utils'
import { navigatePage } from '@/common/utils'
import { useNavigate } from 'react-router-dom'
import { useFileUrlPrefix } from 'shj-utils'
import { BackLog } from './components/BackLog'

export const checkVipPicturePre = (baseUrl, url) => {
  if (url?.startsWith('/upload') || url?.startsWith('upload')) {
    return 'https://shj-member.oss-cn-chengdu.aliyuncs.com/shj' + url
  } else if (url?.startsWith('http')) {
    return url
  } else {
    return baseUrl + url
  }
}

const { TabPane } = Tabs
const workDetail = (props: any) => {
  const [filePrefix] = useFileUrlPrefix()
  const { details } = props
  const files = typeof details?.issueList?.files === 'string' ? JSON.parse(details?.issueList?.files) : []
  return (
    <div>
      <div className={styles.workDetailPage}>
        <div className={styles.workTitle}>
          <div style={{ width: '3px', height: '15px', backgroundColor: '#326ce9' }}></div>
          <div style={{ marginLeft: '5px' }}>客户问题</div>
        </div>
        <Row gutter={[25, 25]} style={{ marginTop: '20px' }}>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>客户姓名</div>
            <div>{details?.customerInfo?.name}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>联系电话</div>
            <div>{details?.issueList?.feedbackPhone}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>签约电话</div>
            <div>{details?.customerInfo?.phone}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>客户状态</div>
            <div>{details?.customerInfo?.stateDisplay}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>问题类型</div>
            <div>{details?.issueList?.typeDisplay}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>问题状态</div>
            <div>{details?.issueList?.statusDisplay}</div>
          </Col>
          <Col span={24} className={styles.workItem}>
            <div className={styles.workLabel}>问题描述</div>
            <div>{details?.issueList?.description}</div>
          </Col>
          <Col span={24} className={styles.workItem}>
            <div className={styles.workLabel}>问题附件</div>
            <div>
              {files?.map?.((item, index) => {
                return (
                  <Image
                    key={index}
                    preview={true}
                    style={{ height: '60px', width: '60px', margin: '5px' }}
                    src={checkVipPicturePre(filePrefix, item.path)}
                    alt={item.name}
                  />
                )
              })}
            </div>
          </Col>
        </Row>
      </div>

      <div className={styles.workDetailPage}>
        <div className={styles.workTitle}>
          <div style={{ width: '3px', height: '15px', backgroundColor: '#326ce9' }}></div>
          <div style={{ marginLeft: '5px' }}> 工单详情</div>
        </div>
        <Row gutter={[25, 25]} style={{ marginTop: '20px' }}>
          <Col span={24} className={styles.workItem}>
            {/* <Row > */}
            <Col span={2}>
              <div style={{ color: '#9d9c9c' }}>工单分类</div>
            </Col>
            <Col span={20}>
              <div>{details?.orderList?.ticketsClassifyList?.map(item => item.classifyName)}</div>
            </Col>
            {/* </Row> */}
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>一级抄送人</div>
            <div>{details?.orderList?.firstLevelCopyPersonList?.map(item => item.name)}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>二级抄送人</div>
            <div>{details?.orderList?.secondLevelCopyPersonList?.map(item => item.name)}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>三级抄送人</div>
            <div>{details?.orderList?.threeLevelCopyPersonList?.map(item => item.name)}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>处理人</div>
            <div>{details?.orderList?.disposeVo?.name}</div>
          </Col>
          <Col span={8} className={styles.workItem}>
            <div className={styles.workLabel}>责任人</div>
            <div>{details?.orderList?.chargeVo?.name}</div>
          </Col>
          <Col span={24} className={styles.workItem}>
            <div className={styles.workLabel}>工单描述</div>
            <div>{details?.orderList?.description}</div>
          </Col>
          <Col span={24} className={styles.workItem}>
            <div className={styles.workLabel}>工单附件</div>
            <div>
              {details?.orderList?.fileList?.map((item, index) => {
                return (
                  <Image
                    key={index}
                    preview={true}
                    style={{ height: '60px', width: '60px', margin: '5px' }}
                    src={checkVipPicturePre(filePrefix, item.path)}
                    alt={item.name}
                  />
                )
              })}
            </div>
          </Col>
        </Row>
      </div>
    </div>
  )
}
export default workDetail
